function _typeof(t) {
  return (_typeof = _typeof ||
    'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
      ? function (t) {
          return typeof t;
        }
      : function (t) {
          return t &&
            'function' === typeof Symbol &&
            t.constructor === Symbol &&
            t !== Symbol.prototype
            ? 'symbol'
            : typeof t;
        })(t);
}
function _defineProperty(t, e, r) {
  return (
    (e = _toPropertyKey(e)) in t
      ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (t[e] = r),
    t
  );
}
function _toPropertyKey(t) {
  t = _toPrimitive(t, 'string');
  return 'symbol' === _typeof(t) ? t : `${t  }`;
}
function _toPrimitive(t, e) {
  if ('object' !== _typeof(t) || !t) return t;
  let r = t[Symbol.toPrimitive];
  if (void 0 === r) return ('string' === e ? String : Number)(t);
  r = r.call(t, e || 'default');
  if ('object' !== _typeof(r)) return r;
  throw new TypeError('@@toPrimitive must return a primitive value.');
}
$(document).ready(() => {
  function n(t, e) {
    return t.split(e);
  }
  ($('.customer').hide(),
    ($('.register-error').length
      ? $('.register-error')
      : $('.customer-registration-quiz .customer')
    ).fadeIn(),
    $('.quiz__btn--close').on('click', () => {
      ($('.quiz').hide(),
        $('.customer-registration-thank-you .customer').fadeIn());
    }),
    $('.quiz-continue').on('click', () => {
      $('.customer__container--welcome').fadeOut();
    }),
    setTimeout(() => {
      $('.quiz__form-slider').slick({
        infinite: !1,
        draggable: !1,
        dots: !0,
        prevArrow: $('.quiz-prev'),
        nextArrow: $('.quiz-next'),
      });
    }, 500),
    $('#no-action').submit((t) => {
      t.preventDefault();
    }));
  let l = '',
    u = '',
    a = '',
    c = '',
    s = ', ';
  ($('.quiz__submit').on('click', () => {
    if (
      ($('.customer-registration-thank-you .customer').fadeIn(),
      (c = a = u = l = '') !== $('#artists').val())
    )
      for (let t = n($('#artists').val(), s), e = 0; e < t.length; e += 1)
        l = `${l + t[e]  }|`;
    if ('' !== $('#photographers').val())
      for (let r = n($('#photographers').val(), s), r_e = 0; r_e < r.length; r_e += 1)
        u = `${u + r[r_e]  }|`;
    if ('' !== $('#genres').val())
      for (let o = n($('#genres').val(), s), o_e = 0; o_e < o.length; o_e += 1)
        a = `${a + o[o_e]  }|`;
    if ('' !== $('#concert').val())
      for (let i = n($('#concert').val(), s), i_e = 0; i_e < i.length; i_e += 1)
        c = `${c + i[i_e]  }|`;
    (('Yes' !== $('#collect_photography').val() &&
      'yes' !== $('#collect_photography').val() &&
      'y' !== $('#collect_photography').val() &&
      'Y' !== $('#collect_photography').val()) ||
      $('#tags_collect_photography').prop('checked', !0),
      ('Yes' !== $('#instrument').val() &&
        'yes' !== $('#instrument').val() &&
        'y' !== $('#instrument').val() &&
        'Y' !== $('#instrument').val()) ||
        $('#tags_instrument').prop('checked', !0),
      $('#tags_artist').val(l.slice(0, -1)),
      $('#tags_photographer').val(u.slice(0, -1)),
      $('#tags_genre').val(a.slice(0, -1)),
      $('#tags_concert').val(c.slice(0, -1)),
      $('#metafields_form').submit(),
      $('#MainContent').removeClass('no-scroll'),
      $('.customer.quiz').removeClass('no-scroll'),
      $('.quiz').fadeOut());
  }),
    $('.form__button.quiz__submit, .form__button.quiz-next').on(
      'click',
      function () {
        let quiz_t = $(this).parents('.quiz__form-slide').children('.quiz__input'),
          quiz_e = `favorite-${  $(quiz_t).attr('id')}`,
          quiz_val = $(quiz_t).val();
        '' !== quiz_val &&
          ((quiz_e = _defineProperty({}, quiz_e, quiz_val)), _learnq.push(['identify', quiz_e]));
      }
    ));
});
